var React = require('react');

function ShoppingCartBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.06 9.202l-.93-3.726A1.95 1.95 0 0014.236 4H9.763a1.95 1.95 0 00-1.892 1.476l-.93 3.726H3l2.556 10.23a1.95 1.95 0 001.892 1.476h9.104a1.95 1.95 0 001.892-1.477L21 9.202h-3.94zm-5.71 6.503v3.902H9.939l-.735-3.902h2.146zm-2.387-1.3l-.735-3.902h3.122v3.902H8.963zm3.687 1.3h2.146l-.735 3.902h-1.41v-3.902zm0-1.3v-3.902h3.122l-.735 3.902H12.65zm4.442-3.902h2.243l-.975 3.902h-2.003l.735-3.902zm-7.96-4.708a.65.65 0 01.65-.494h4.475a.65.65 0 01.65.494l.813 3.407H8.28l.852-3.407zm-2.224 4.708l.735 3.902H5.64l-.975-3.902h2.243zm-.11 8.61l-.833-3.408h1.951l.729 3.902H7.448a.65.65 0 01-.65-.494zm10.365 0a.65.65 0 01-.611.494h-1.164l.728-3.902h1.951l-.904 3.408z","fill":"#31aded","fillRule":"evenodd"}));
}

ShoppingCartBlue.defaultProps = {"width":"24","height":"24"};

module.exports = ShoppingCartBlue;

ShoppingCartBlue.default = ShoppingCartBlue;
